import React, { useEffect, useState } from 'react';
import { Tree } from 'react-arborist';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import { ProcessDnDTreeviewData } from 'services/EVAEditGridService';
import { TransformSQLResult } from 'services/EVAEditGridService';
import GridContent from './GridContent';
import ReactBSAlert from "react-bootstrap-sweetalert";
import { ProcessRenamingSQLData } from 'services/EVAEditGridService';
import { RecalculateWithTotal } from 'services/EVAEditGridService';
import { TableHeader } from 'services/EVAEditGridService';
import { GetCellIdValue } from 'services/EVAEditGridService';
import { GenerateUniqueID } from 'services/EVAEditGridService';
import { PopulateNewRows } from 'services/EVAEditGridService';
import { PopulateChangeSequence } from 'services/EVAEditGridService';

function GridEditLayout({ isWithChild, isSubWithChild, data, item, sqlresult, gridHeader, 
    saveChanges, hanldeEditGridSorting, handleNewRowList, handleDragAndDropData, handleChangeSequence,
    handleAddUpdateCellFormulaList, handleGridGroupLevel, handleToggleEditGrid, handleRenamedSQLData,
    handleHiddenRow, handleRenamedColumn, handleNewAddedColumn }) 
{
    const [treeData, setTreeData] = useState([])
    const [screenHeight, setScreenHeight] = useState(window.innerHeight);
    const [gridGroupLevel, setGridGroupLevel] = useState(null)
    const [tableHeader, setTableHeader] = useState([])
    const [sortingData, setSortingData] = useState([])

    const [newRowList, setNewRowList] = useState([])
    const [dragAndDropData, setDragAndDropData] = useState([])
    const [cellFormulaList, setCellFormulaList] = useState([])
    const [renamedSQLData, setRenamedSQLData] = useState([])
    const [hiddenRow, setHiddenRow] = useState([])
    const [renamedHeaderList, setRenamedHeaderList] = useState([])
    const [addedNewColumnHeader, setAddedNewColumnHeader] = useState([])

    const [selectedCellFormula, setSelectedCellFormula] = useState('')
    const [selectedCellId, setSelectedCellId] = useState('')
    const [selectedRowId, setSelectedRowId] = useState('')
    const [selectedRowSQLId, setSelectedRowSQLId] = useState('')
    const [rowIndexCount, setRowIndexCount] = useState(0)
    const [onEditCell, setOnEditCell] = useState(false)
    const [childListCellValue, setChildListCellValue] = useState([])
    const [selectedRowHeaderforFormula, setSelectedRowHeaderforFormula] = useState([])
    const [selectedHeader, setSelectedHeader] = useState(null)
    const [columnHeader, setColumnHeader] = useState(gridHeader)
    const [columnHeaderData, setColumnHeaderData] = useState([])
    const [newUpdateCount, setNewUpdateCount] = useState(0)
    const [changeSequence, setChangeSequence] = useState([])

    useEffect(() => {
        if(item && item.editedGridCellData) {
            const { gridGroupLevel, newRowList, dragAndDropData, cellFormulaList, renamedSQLData, hiddenRow, addedColumnList, changeSequence } = item.editedGridCellData
            
            console.log(changeSequence)
            setChangeSequence(changeSequence)
            setAddedNewColumnHeader(addedColumnList)
            setGridGroupLevel(gridGroupLevel)
            // setNewRowList(newRowList)
            setCellFormulaList(cellFormulaList)
            setTimeout(() => {
                // setDragAndDropData(dragAndDropData)
                setRenamedSQLData(renamedSQLData)
            }, 100);
            setHiddenRow(hiddenRow)
        }
    }, [item])
    useEffect(() => {
        // console.log(newRowList[newRowList.length - 1])
        // console.log(newRowList)
        handleNewRowList(newRowList)
        handleSetSelectedNode(newRowList)
        function handleSetSelectedNode(id, sqlId, name)
        {
            const rowData = newRowList[newRowList.length - 1]
            if(rowData)
            {
                setSelectedNodes([rowData.id])
                setSelectedNode([rowData.id, rowData.sqlId, rowData.name, false])
            }
        }
        // if(newRowList[newRowList.length - 1])
            // handleSequenceChanges('newRow', newRowList[newRowList.length - 1])
    }, [newRowList]);  

    useEffect(() => {
        // console.log("drag&drop", dragAndDropData)
        handleDragAndDropData(dragAndDropData)

        if(dragAndDropData[dragAndDropData.length - 1])
            handleSequenceChanges('dragAndDrop', dragAndDropData[dragAndDropData.length - 1])
    }, [dragAndDropData]);  

    useEffect(() => {
        // console.log(changeSequence)
        handleChangeSequence(changeSequence)
    }, [changeSequence]);  

    const handleSequenceChanges = (step, newData) => {
        setChangeSequence(prev => {
            if (step === 'newRow') {
                const index = prev.findIndex(item => item.newData.sqlId === newData.sqlId);
    
                if (index !== -1) {
                    const updated = [...prev];
                    updated.splice(index, 1);
                    updated.push({ step, newData });
                    return updated;
                }
    
                return [...prev, { step, newData }];
            } else if (step === 'dragAndDrop') {
                const updated = prev.filter(item => {
                    if (item.step !== 'dragAndDrop') return true;
                    return item.newData.dragIds[0] !== newData.dragIds[0];
                });
    
                return [...updated, { step, newData }];
            }
    
            return prev;
        });
    };
      

    useEffect(() => {
        handleGridGroupLevel(gridGroupLevel)
    }, [gridGroupLevel])
    useEffect(() => {
        handleRenamedSQLData(renamedSQLData)
    }, [renamedSQLData])
    useEffect(() => {
        handleHiddenRow(hiddenRow)
    }, [hiddenRow])
    useEffect(() => {
        handleAddUpdateCellFormulaList(cellFormulaList)
    }, [cellFormulaList])
    useEffect(() => {
        setSortingData(sqlresult)
    },[sqlresult])
    useEffect(() => {
        if(treeData && treeData.length > 0) {
            hanldeEditGridSorting(treeData)
        }
    },[treeData])
    useEffect(() => {
        handleRenamedColumn(renamedHeaderList)
        ProcessColumnRename()
    },[renamedHeaderList])
    useEffect(() => {
        handleNewAddedColumn(addedNewColumnHeader)
    },[addedNewColumnHeader])

    const ProcessColumnRename = () => {

        if (renamedHeaderList.length === 0) return

        const newColumnHeader = [...columnHeader]
        renamedHeaderList && renamedHeaderList.map((item, index) => {
            const colIndex = columnHeader.findIndex(i => i === item.oldHeader)
            newColumnHeader[colIndex] =  item.newHeader
        })
        setColumnHeader(newColumnHeader)
    }

    useEffect(() => {   
        const headerData = processDefaultHeader(gridHeader)
        setColumnHeaderData(headerData)
    }, [gridHeader])

    const processDefaultHeader = (gridHeader) => {
        const headerData = []
        gridHeader && gridHeader.map((item, index) => {
            const param = {
                colIndex: index,
                sqlId: item,
            }
            headerData.push(param)
        })

        return headerData
    }

    useEffect(() => {

        const processEditGrid = async () => {
            let header = gridHeader
            let sqlData = sortingData
            let updatedNewRowList = newRowList

            const calculateGroupLevel = () => {
                if (!isWithChild && !isSubWithChild) return 1;
                if (isWithChild && !isSubWithChild) return 2;
                return 3;
            };
            const processRenaming = async (treeData) => {
                // console.log(renamedSQLData)
                if (renamedSQLData && renamedSQLData.length > 0) {
                    return ProcessRenamingSQLData(renamedSQLData, treeData);
                }
                return treeData;
            };
            const processHiddenRow = async (hiddenRow, treeData) => {
                if(!hiddenRow) return treeData
                for(let r = 0; r < hiddenRow.length; r++)
                {
                    const id = hiddenRow[r]
                    for(let d = 0; d < treeData.length; d++)
                    {
                        findItemToHide(treeData, id)
                    }
                }
                
        
                function findItemToHide (parent, id) {
                
                    for (let i = 0; i < parent.length; i++) {
                        if(parent[i].sqlId === id) {
                            parent[i].isHidden = true;
        
                            if(parent[i].children)
                                setChildtoHide(parent[i].children)
                        }
        
                        if (parent[i].children) {
                            findItemToHide(parent[i].children, id)
                        }
                    }
                }
        
                function setChildtoHide (parent) {
                    
                    for (let i = 0; i < parent.length; i++) {
                        parent[i].isHidden = true;
                        if (parent[i].children) {
                            setChildtoHide(parent[i].children)
                        }
                    }
                }
                return treeData
            }
            const processNewHeader = (sqlData, newRowList) => {

                let header = [...gridHeader];
                let updatedData = [...sqlData];
                let updateRowList = JSON.parse(JSON.stringify(newRowList));
                
                if (addedNewColumnHeader && addedNewColumnHeader.length > 0) {
                    addedNewColumnHeader.map(item => {
                        header.push(item.name);
                        addZeroToRow(updateRowList);
                    });
                    updatedData = sqlData.map(item => [...item, 0]);
                }
            
                function addZeroToRow(updateRowList) {
                    for (let i = 0; i < updateRowList.length; i++) {
                        const row = updateRowList[i];
                        if (row.value) row.value = [...row.value, 0];
                        if (row.children) addZeroToRow(row.children);
                    }
                }
            
                return { header, updatedData, updateRowList };
            };
            
            if(addedNewColumnHeader && addedNewColumnHeader.length > 0) {
                const headerData = processNewHeader(sqlData, newRowList);
                header = headerData.header
                sqlData = headerData.updatedData
                updatedNewRowList = headerData.updateRowList
            }

            const groupLevel = calculateGroupLevel();
            const { result, newHeader, dataIndex } = TransformSQLResult(sqlData, columnHeader, groupLevel);

            setGridGroupLevel(groupLevel);
            setRowIndexCount(dataIndex);
            setTableHeader(newHeader);

            let newTreeData = result;
            let cellIdValueList = await GetCellIdValue([...newTreeData])
            await checkDataChangesForFormula(cellIdValueList, cellFormulaList)

            newTreeData = changeSequence && changeSequence.length > 0 ? await PopulateChangeSequence(changeSequence, newTreeData, cellIdValueList, sqlData, header, groupLevel, dragAndDropData) : newTreeData

            // newTreeData = processNewRows(newTreeData, cellIdValueList);
            // newTreeData = processDragAndDropData(newTreeData);
            newTreeData = await processRenaming(newTreeData);
            newTreeData = await processGroupWithTotal(newTreeData, cellIdValueList, addedNewColumnHeader)
            newTreeData = await processGrandTotal(newTreeData, cellIdValueList, updatedNewRowList)
            cellIdValueList = await GetCellIdValue(newTreeData)
            newTreeData = await processGrandParentRow(updatedNewRowList, newTreeData)
            newTreeData = await processHiddenRow(hiddenRow,newTreeData)
            cellIdValueList = await GetCellIdValue(newTreeData)
            setChildListCellValue(cellIdValueList)
      
            setTreeData(newTreeData);
        }

        processEditGrid()
        
    }, [sortingData, dragAndDropData, isSubWithChild, newRowList, gridGroupLevel, renamedSQLData, hiddenRow, cellFormulaList, columnHeader, addedNewColumnHeader, newUpdateCount, changeSequence, renamedHeaderList]);

    const PopulateChangeSequence = async(changeSequence, newTreeData, cellIdValueList, sqlData, header, groupLevel, dragAndDropData) => {
        let treeData = newTreeData
    
        const processNewRows = async(data, treeData, cellIdValueList) => {
            if (data && data.length > 0) {
                const updateRowList = loopThruItems(data, cellIdValueList)
                return PopulateNewRows(updateRowList, treeData, header, groupLevel);
            }
    
            function loopThruItems(data)
            {
                for(let i = 0; i < data.length; i++)
                {
                    const row = data[i]
                    // if(row) return 
                    const item = cellIdValueList.find(i => i.sqlId === row.sqlId)
    
                    if(item && item?.id !== row.id) row.id = item?.id
                    
                    if(row.children) loopThruItems(row.children)
                }
                return data
            }
            return treeData;
        };
    
        const processDragAndDropData = async(treeData) => {
            if (dragAndDropData.length > 0 && treeData.length > 0) {
             
                let updatedTreeData = ProcessDnDTreeviewData(dragAndDropData, treeData);
                const hasGroupedItems = dragAndDropData.some(g => g.parentId && g.parentId.includes("-group-"));
                if (hasGroupedItems) {
                    updatedTreeData = RecalculateWithTotal(updatedTreeData);
                }
    
                return updatedTreeData;
            }
            return treeData;
        };
    
        for (let i = 0; i < changeSequence.length; i++) {
            const step = changeSequence[i].step
            const data = [changeSequence[i].newData]
            if(step==="newRow") {
                treeData = await processNewRows(data, treeData, cellIdValueList)
            } else if(step === "dragAndDrop") {
                treeData = await processDragAndDropData(treeData)
            }

            // console.log(treeData)
        }
        return treeData
    }

    const checkDataChangesForFormula = async (cellValue, cellFormulaList) => {
        for (let f = 0; f < cellFormulaList.length; f++) {
            const formulaItem = cellFormulaList[f];
            for (let i = 0; i < formulaItem.cellIdwithSQLId.length; i++) {
                const cellIdwithSQLId = formulaItem.cellIdwithSQLId[i];
    
                if (cellIdwithSQLId && cellIdwithSQLId.cellId) {
                    const { sqlId, cellId, columnIndex } = cellIdwithSQLId;
                    const cellValueItem = cellValue.find(cell => cell.cellId === cellId);
                
                    if (!cellValueItem) {
                        // console.warn(`cellValueItem not found for cellId: ${cellId}. Skipping this entry.`);
                        continue;
                    }
                    
                    if (sqlId !== cellValueItem.sqlId) {
                        let oldFormula = cellFormulaList[f].formula;
                        // Find the correct cell value based on sqlId
                        let correctCellValue = cellValue.filter(cell => cell.sqlId === sqlId);
                        correctCellValue = correctCellValue[columnIndex]

                        // Validate that correctCellValue exists
                        if (!correctCellValue || !correctCellValue.cellId) {
                            console.warn(`correctCellValue not found for sqlId: ${sqlId}. Skipping this entry.`);
                            continue;
                        }
                        // Use the regular expression to safely replace the old cellId with the new one
                        const newFormula = oldFormula.replace(new RegExp(`\\b${cellId}\\b`, 'g'), correctCellValue.cellId);
    
                        // Update the formula and the cellId
                        cellFormulaList[f].formula = newFormula;
                        cellFormulaList[f].cellIdwithSQLId[i].cellId = correctCellValue.cellId;

                        console.log(oldFormula)
                        console.log(newFormula)
                    }
                } else {
                    // console.log(cellIdwithSQLId)
                    // console.warn(`cellIdwithSQLId is missing or invalid at index ${i} in formula ${f}. Skipping.`);
                }
            }
        }
    };
    useEffect(() => {
        // console.log(sqlresult)
        // console.log(childListCellValue)
    },[childListCellValue])
    
    const GetCellIdValue = async (newTreeData) => {
        const cellIdValue = []
           
        getFindCellValue(newTreeData)
    
        function getFindCellValue(parent)
        {
            for (let i = 0; i < parent.length; i++) {
                if(parent[i].value) {
                    parent[i].value.map((val, index) => {
                        const data = {
                            id: parent[i].id,
                            sqlId: parent[i].sqlId,
                            cellId: getCellId(parent[i].sqlId, parent, i,index),
                            cellValue: isNaN(parseFloat(val)) ? 0 : val
                        }

                        cellIdValue.push(data)
                    })
                }
    
                if(parent[i].children) {
                    getFindCellValue(parent[i].children)
                }
            }
        }
    
        function getCellId(sqlId, parent, i, index) {
            try {
                if(sqlId.includes("-TotalRow"))
                {
                    const parts = sqlId.split('-');
                    const secondToLastItem = parts.slice(1, -1).join('-');
                    return `[${secondToLastItem}-${TableHeader(index)}]`
                }
                if(sqlId.includes("grand-total")) {
                    return `[${sqlId}-${TableHeader(index)}]`
                }
                return `${TableHeader(index)}${parent[i].id.split("-")[0]}`
            }catch(error) {
                return `${TableHeader(index)}${parent[i].id.split("-")[0]}`
            }
        }
    
        return cellIdValue
    }
    const processGrandTotal = async (newTreeData, cellIdValue) => {
        const toSum = []
        loopThruItems(newTreeData)
        function loopThruItems(newTreeData)
        {
            for(let i = 0; i < newTreeData.length; i++)
            {
                if(newTreeData[i].children)
                {
                    const subTotal = calculateSubTotal({ children: newTreeData[i].children }, newTreeData[i].children);
                    toSum.push(subTotal)
                } else {
                    if (newTreeData[i].value) {
                        const subTotal = calculateSubTotal(newTreeData[i] , newTreeData[i].children);
                        toSum.push(subTotal)
                    }
                }
            }
        }

        function childCounter(row, childCount) {
            for (let i = 0; i < row.length; i++) 
            {
                const parent = row[i];
                if(parent.value && !parent.id.includes('-TotalRow'))
                {
                    childCount++;
                }

                if (parent.children) {
                    // Recursively count children and update childCount
                    childCount = childCounter(parent.children, childCount);
                }
            }
            // Return the accumulated child count
            return childCount;
        }

        const sumColumns = (array) => {
             // Check if the input array is defined and has at least one element
            if (!array || array.length === 0 || !Array.isArray(array[0])) {
                // console.error("Invalid input: The array is undefined, empty, or not a 2D array.");
                return [];
            }

            const sums = [];
            let rowCount = 0
            
            // Iterate over each column index
            for (let col = 0; col < array[0].length; col++) {
                let sum = 0;
                let isStringCount = 0
                // Sum each value in the current column
                for (let row = 0; row < array.length; row++) {
                    if(isNaN(parseFloat(array[row][col]))) isStringCount++
                    sum += array[row][col];
                }

                sums.push(isStringCount > 0 ? "-" : sum);
                rowCount++
            }
            // console.log(rowCount)
            return sums;
        };

        let childCount = childCounter(newTreeData, 0);

        // Calculate the sum for each column
        const columnSums = sumColumns(toSum);

        const newRow = {
            "id": "grand-total",
            "sqlId": "grand-total",
            "name": "Grand Total",
            "value": reformatSumPercentage(columnSums, childCount)
        }

        function reformatSumPercentage(newSub, loopCount) {
            const result = newSub.map((item, i) => {
                if (columnHeader[i + gridGroupLevel] && columnHeader[i + gridGroupLevel].includes("%")) {
                    return `${(item / loopCount).toFixed(2)} %`;
                } else {
                    return item;
                }
            });
            return result;
        }
        

        const isGrandTotalExisit = newRowList.find(i => i.id === newRow.id)

        if(!isGrandTotalExisit) 
        {
            setNewRowList(prev => [...prev, newRow])
            handleSequenceChanges('newRow', newRow)
        } else {
            newRow.name = isGrandTotalExisit.name
        }

        newTreeData.push(newRow)
        return newTreeData
        
        function calculateSubTotal(node, newTreeData) {
            // Determine the length of the values array from the first item in newTreeData
            let length = (columnHeader.length - gridGroupLevel) + (addedNewColumnHeader ? addedNewColumnHeader.length: 0)
            // Initialize subtotal and containsString arrays
            let subtotal = Array(length).fill(0);
            let containsString = Array(length).fill(false);
          
         
            // // Check if the node should be skipped
            // if (node.id && node.id.includes("groupTotal")) {
            //   // Skip this node and return the initial subtotal
            //   return subtotal;
            // }

            // Check if the node should be skipped
            if (node.id && (node.id.includes("groupTotal") 
            || (node.id.includes("-parent-") && node.value)
            || (node.id.includes("-sub-") && node.value))) {
            // Skip this node and return the initial subtotal
                return subtotal;
            } 
         
            // Base case: If the node has no children, process its values
            if (!node.children || node.children.length === 0) {
              if (node.value) {
                // Map values, converting to numbers or "-" if non-numeric
                return node.value.map((v, i) => {
                    const cellId = `${TableHeader(i)}${node.id.split("-")[0]}`
                    const formulaData = cellFormulaList.find(f => f.rowId === node.id && f.cellId === cellId)
                    const cellData = cellIdValue.find(i => i.id === node.id && i.cellId === cellId)
                    const amount = formulaData ? isNaN(parseFloat(formulaData.newValue)) ? "-" : formulaData.newValue : cellData ? isNaN(parseFloat(v)) ? "-" : cellData.cellValue : 0
                    // console.log({ formulaData, cellData, v })
                    return (isNaN(parseFloat(amount)) ? "-" : parseFloat(amount) || 0)
                });
              }
              return subtotal; // Return initial subtotal if no values are found
            }
          
            // Recursive case: Traverse each child node
            for (const child of node.children) {
              const childTotal = calculateSubTotal(child, newTreeData);
          
              // Accumulate child totals into subtotal
              for (let i = 0; i < subtotal.length; i++) {
                if (isNaN(childTotal[i])) {
                  containsString[i] = true; // Mark if any child total is non-numeric
                } else {
                  subtotal[i] += parseFloat(childTotal[i]) || 0; // Accumulate numeric values
                }
              }
            }
          
            // Return the final subtotal, replacing numeric values with "-" where needed
            return subtotal.map((total, index) => (containsString[index] ? "-" : total));
        }
    }
    const processGrandParentRow = async (rows, newTreeData) => {

        rows.forEach((row) => {
            const rowData = row.id.split("-");
            const groupLevel = rowData[1];
            switch (groupLevel) {
                case "grandParent":
                    if(row.nextTo)
                    {
                        const existingIndex = newTreeData.findIndex(p => p.sqlId === row.sqlId)
                        const index = newTreeData.findIndex(i => i.sqlId === row.nextTo)

                        if (existingIndex === -1 && index !== -1) {
                            newTreeData.splice(index + 1, 0, row)
                        }else {
                            newTreeData.push(row)
                        }
                    }
                    break;
                default:
                    break;
            }
        });

        return newTreeData
    }
    const processGroupWithTotal = async (newTreeData, cellIdValue) => {
        loopThruItems(newTreeData, 0)

        function loopThruItems(newTreeData, depthLevel)
        {
            for(let i = 0; i < newTreeData.length; i++)
            {
                const row = newTreeData[i]
             
                if(row.children)
                {
                    let childCount = childCounter(row.children, 0);
                    const newSub = calculateSubTotal({ children: row.children }, row.children);
                    const newChild = {
                        "id": `${row.id}-TotalRow`,
                        "sqlId": `${row.sqlId}-TotalRow`,
                        "name": `Total ${row.name}`,
                        "value": reformatSumPercentage(newSub, childCount)
                    }
                    const index = row.children ? row.children.findIndex(d => d.id === newChild.id) : -1
                    if(index !== -1)
                    {
                        row.children.splice(index, 1)
                    }

                    row.children.push(newChild)
                    loopThruItems(row.children, depthLevel + 1)
                } 
            }
        }

        function childCounter(row, childCount) {
            for (let i = 0; i < row.length; i++) 
            {
                const parent = row[i];
                if(parent.value && !parent.id.includes('-TotalRow'))
                {
                    childCount++;
                }

                if (parent.children) {
                    // Recursively count children and update childCount
                    childCount = childCounter(parent.children, childCount);
                }
            }
            // Return the accumulated child count
            return childCount;
        }

        function reformatSumPercentage(newSub, loopCount) {
            const result = newSub.map((item, i) => {
                const headerItem = columnHeader[i + gridGroupLevel];
                
                if (headerItem?.includes("%")) {
                    return `${(item / loopCount).toFixed(2)} %`;
                } else {
                    return item;
                }
            });
            return result;
        }
        

        const cellIdValueList = GetCellIdValue([...newTreeData])
        setChildListCellValue(cellIdValueList)
        return newTreeData
     
        function calculateSubTotal(node, newTreeData) {

            // console.log({ node, newTreeData })
            // Determine the length of the values array from the first item in newTreeData
            let length = (columnHeader.length - gridGroupLevel) + (addedNewColumnHeader ? addedNewColumnHeader.length: 0)
            // Initialize subtotal and containsString arrays
            let subtotal = Array(length).fill(0);
            let containsString = Array(length).fill(false);
          
            // Check if the node should be skipped
            if (node.id && (node.id.includes("groupTotal") || (node.id.includes("-New Row") && node.id.includes("-sub-")))) {
              // Skip this node and return the initial subtotal
              return subtotal;
            }
         
            // Base case: If the node has no children, process its values
            if (!node.children || node.children.length === 0) {
              if (node.value) {
                // Map values, converting to numbers or "-" if non-numeric
                return node.value.map((v, i) => {
                    // console.log(node.id, v, i)
                    const cellId = `${TableHeader(i)}${node.id.split("-")[0]}`
                    const formulaData = cellFormulaList.find(f => f.rowId === node.id && f.cellId === cellId )
                    const cellData = cellIdValue.find(i => i.id === node.id && i.cellId === cellId)
                    const amount = formulaData ? isNaN(parseFloat(formulaData.newValue)) ? "-" : formulaData.newValue : cellData ? isNaN(parseFloat(v)) ? "-" : cellData.cellValue : 0
                    return (isNaN(amount) ? "-" : parseFloat(amount) || 0)
                });
              }
              return subtotal; // Return initial subtotal if no values are found
            }
          
            // Recursive case: Traverse each child node
            for (const child of node.children) {
                const childTotal = calculateSubTotal(child, newTreeData);

                // Accumulate child totals into subtotal
                if(childTotal.newSub)
                {
                    for (let i = 0; i < subtotal.length; i++) {
                        if (isNaN(childTotal.newSub[i])) {
                        containsString[i] = true; // Mark if any child total is non-numeric
                        } else {
                        subtotal[i] += parseFloat(childTotal.newSub[i]) || 0; // Accumulate numeric values
                        }
                    }
                } else {
                    for (let i = 0; i < subtotal.length; i++) {
                        if (isNaN(childTotal[i])) {
                        containsString[i] = true; // Mark if any child total is non-numeric
                        } else {
                        subtotal[i] += parseFloat(childTotal[i]) || 0; // Accumulate numeric values
                        }
                    }
                }
               
            }
            // console.log(subtotal)
            // Return the final subtotal, replacing numeric values with "-" where needed
            return subtotal.map((total, index) => (containsString[index] ? "-" : total));
        }
    }
    const handleSaveChanges = (e) => {
        e.preventDefault()
        saveChanges()
    }
    const onMove = ({ dragIds, parentId, index }) => {

        const newRowData = { dragIds: [getSQLIdById(dragIds)], parentId: getSQLIdById(parentId), index };

        setDragAndDropData(prev => {
            if (!Array.isArray(prev)) {
                prev = [];
            }
            return [...prev, newRowData];
        });
    };
    const getSQLIdById = (id) => {
        if(id) {
            const newId = Array.isArray(id) ? id[0] : id;
            const treeSqlId = findItemById(treeData, newId);
            const item = childListCellValue.find(i => i.id === newId);

            if(treeSqlId)
                return treeSqlId.sqlId
        
            return item ? item.sqlId : newId.split('-').slice(1).join('-');
        } return null
    }
    const findItemById = (treeData, id) => {
        for (const item of treeData) {
            if (item.id === id) {
                return item;
            }
    
            if (item.children && item.children.length > 0) {
                const found = findItemById(item.children, id);
                if (found) {
                    return found;
                }
            }
        }
        return null;
    };
    
    const [selectedNode, setSelectedNode] = useState(['',''])
    const [selectedNodes, setSelectedNodes] = useState([]);

    useEffect(() => {
        // console.log(selectedNode)
    },[selectedNodes, selectedNode])

    function handleTreeItemClick(e, id, sqlId, nodeName, isHidden) {
        setSelectedHeader(null)
        if(e.shiftKey) {
            // console.log(id.split("-")[1])

            if(id.split("-")[1] === "child")
                setSelectedNodes(prevSelectedNodes => 
                    prevSelectedNodes.includes(id) 
                    ? prevSelectedNodes.filter(nodeId => nodeId !== id) 
                    : [...prevSelectedNodes, id]
                );
        } else {

            if(onEditCell){  

            }else {
                setSelectedNodes([id])
                setSelectedNode([id, sqlId, nodeName, isHidden])
            }
        }
    }
   
    const handleAddRow = (e, selectedNode, isWithChild = false, isAddChild = false) => {
        e.preventDefault()
        selectedNode[0] = selectedNode[0].replace("-TotalRow","")
        const newIndex = rowIndexCount + newRowList.length + 1
        const rowData = selectedNode[0].split("-")
        const newData = [...sortingData]
        const groupLevel = selectedNode[0].split("-")[1]
        const deductionCount = gridGroupLevel
        const newRow = new Array(newData[0].length - deductionCount).fill(''); 

        switch(groupLevel)
        {
            case "child": 
                const newItem = {
                    nextTo: selectedNode[1],
                    id: gridGroupLevel === 3 ? `${newIndex}-child-${rowData[2]}-${rowData[3]}-New Row ${newIndex}`
                        : gridGroupLevel === 2 ? `${newIndex}-child-${rowData[2]}-New Row ${newIndex}`
                        : `${newIndex}-child-New Row ${newIndex}`,
                    sqlId: GenerateUniqueID(),
                    name:`New Row ${newIndex}`,
                    value: newRow
                }
                setNewRowList(prev => [...prev, newItem])
                handleSequenceChanges('newRow', newItem)
            break;
            case "sub": 
                if(isAddChild) {
                    let splitData = selectedNode[0].split('-');
                    const newChildItem = {
                        id: `${newIndex + 1}-child-${splitData.slice(2).join('-')}-New Row ${newIndex + 1}`,
                        sqlId: GenerateUniqueID(),
                        name:`New Row ${newIndex + 1}`,
                        value: newRow
                    }
                    setNewRowList(prev => [...prev, newChildItem])
                    handleSequenceChanges('newRow', newChildItem)
                } else if (gridGroupLevel === 3) {
                    if(isWithChild)
                    {
                        const newSubItem = {
                            nextTo: selectedNode[1],
                            id: `${newIndex}-sub-${rowData[2]}-New Row ${newIndex}`,
                            sqlId: GenerateUniqueID(),
                            name:`New Row ${newIndex}`,
                            children: []
                        }
                        setNewRowList(prev => [...prev, newSubItem])
                        handleSequenceChanges('newRow', newSubItem)
                        const newChildItem = {
                            parent: newSubItem.sqlId,
                            id: `${newIndex + 1}-child-${rowData[2]}-New Row ${newIndex}-New Row ${newIndex + 1}`,
                            sqlId: GenerateUniqueID(),
                            name:`New Row ${newIndex + 1}`,
                            value: newRow
                        }
                        setNewRowList(prev => [...prev, newChildItem])
                        handleSequenceChanges('newRow', newChildItem)
                    }else {
                        const newSubItem = {
                            nextTo: selectedNode[1],
                            id: `${newIndex}-sub-${rowData[2]}-New Row ${newIndex}`,
                            sqlId: GenerateUniqueID(),
                            name:`New Row ${newIndex}`,
                            value: newRow
                        }
                        setNewRowList(prev => [...prev, newSubItem])
                        handleSequenceChanges('newRow', newSubItem)
                    }
                    
                } else if(gridGroupLevel === 2) {

                    if(isWithChild) {
                        const newSubItem = {
                            nextTo: selectedNode[1],
                            id: `${newIndex}-sub-New Row ${newIndex}`,
                            sqlId: GenerateUniqueID(),
                            name:`New Row ${newIndex}`,
                            children: []
                        }
                        setNewRowList(prev => [...prev, newSubItem])
                        handleSequenceChanges('newRow', newSubItem)

                        const newChildItem = {
                            parent: newSubItem.sqlId,
                            id: `${newIndex + 1}-child-New Row ${newIndex}-New Row ${newIndex + 1}`,
                            sqlId: GenerateUniqueID(),
                            name:`New Row ${newIndex + 1}`,
                            value: newRow
                        }
                        setNewRowList(prev => [...prev, newChildItem])
                        handleSequenceChanges('newRow', newChildItem)
                    }else {
                        const newSubItem = {
                            nextTo: selectedNode[1],
                            id: `${newIndex}-sub-New Row ${newIndex}`,
                            sqlId: GenerateUniqueID(),
                            name:`New Row ${newIndex}`,
                            value: newRow
                        }
                        setNewRowList(prev => [...prev, newSubItem])
                        handleSequenceChanges('newRow', newSubItem)
                    }
                    
                } else {
                    const newSubItem = {
                        nextTo: selectedNode[1],
                        id: `${newIndex}-sub-${rowData[2]}-New Row ${newIndex}`,
                        sqlId: GenerateUniqueID(),
                        name:`New Row ${newIndex}`,
                        value: newRow
                    }
                    setNewRowList(prev => [...prev, newSubItem])
                    handleSequenceChanges('newRow', newSubItem)
                }
            break;
            case "parent": 
                if(isAddChild) {
                    let splitData = selectedNode[1].split('-');
                    const newChildItem = {
                        id: `${newIndex + 1}-child-${splitData.slice(2).join('-')}-New Row ${newIndex + 1}`,
                        sqlId: GenerateUniqueID(),
                        name:`New Row ${newIndex + 1}`,
                        value: newRow
                    }
                    setNewRowList(prev => [...prev, newChildItem])
                    handleSequenceChanges('newRow', newChildItem)
                } else{
                // if(gridGroupLevel === 3) { 
                    if(isWithChild) {
                        const newParentItem = {
                            nextTo: selectedNode[1],
                            id: `${newIndex}-parent-New Row ${newIndex}`,
                            sqlId: GenerateUniqueID(),
                            name:`New Row ${newIndex}`,
                            children: []
                        }
                        setNewRowList(prev => [...prev, newParentItem])
                        handleSequenceChanges('newRow', newParentItem)
                        const newSubItem = {
                            parent: newParentItem.sqlId,
                            id: `${newIndex + 1}-sub-${newParentItem.name}-New Row ${newIndex + 1}`,
                            sqlId: GenerateUniqueID(),
                            name:`New Row ${newIndex + 1}`,
                            children: []
                        }
                        setNewRowList(prev => [...prev, newSubItem])
                        handleSequenceChanges('newRow', newSubItem)
                        const newChildItem = {
                            parent: newSubItem.sqlId,
                            id: `${newIndex + 2}-child-${newParentItem.name}-${newSubItem.name}-New Row ${newIndex + 2}`,
                            sqlId: GenerateUniqueID(),
                            name:`New Row ${newIndex + 2}`,
                            value: newRow
                        }
                        setNewRowList(prev => [...prev, newChildItem])
                        handleSequenceChanges('newRow', newChildItem)
                    }else {
                        const newParentItem = {
                            nextTo: selectedNode[1],
                            id: `${newIndex}-parent-New Row ${newIndex}`,
                            sqlId: GenerateUniqueID(),
                            name:`New Row ${newIndex}`,
                            value: newRow
                        }
                        setNewRowList(prev => [...prev, newParentItem])
                        handleSequenceChanges('newRow', newParentItem)
                    }
                }
                break;
            case "total": 
                const newGrandParentItem = {
                    nextTo: selectedNode[1],
                    id: `${newIndex}-grandParent-New Row ${newIndex}`,
                    sqlId: GenerateUniqueID(),
                    name:`New Row ${newIndex}`,
                    value: newRow
                }

                setNewRowList(prev => [...prev, newGrandParentItem])
                handleSequenceChanges('newRow', newGrandParentItem)
            break;
            case "grandParent": 
                const addedGrandParentItem = {
                    nextTo: selectedNode[1],
                    id: `${newIndex}-grandParent-New Row ${newIndex}`,
                    sqlId: GenerateUniqueID(),
                    name:`New Row ${newIndex}`,
                    value: newRow
                }
                setNewRowList(prev => [...prev, addedGrandParentItem])
                handleSequenceChanges('newRow', addedGrandParentItem)
            break;
        }
    }
    const handleAddParentGroupings = (e, selectedNode, isWithTotal = false) => {
        e.preventDefault()
        const newIndex = rowIndexCount + newRowList.length
        const newData = [...sortingData]
        const newRow = new Array(newData[0].length - gridGroupLevel).fill(''); 
        const groupLevel = selectedNodes[0].split("-")[1]
        const parent = selectedNodes[0].split("-")[2]
        const sub = selectedNodes[0].split("-")[3]

        switch(groupLevel)
        {
            case "child": 
                if(selectedNodes.length > 0)
                {
                    const newChildItem = {
                        isWithTotal: isWithTotal,
                        id: `${newIndex + 1}-group-${parent}-${sub}-New Row ${newIndex + 1}`,
                        sqlId: `group-${parent}-${sub}-New Row ${newIndex + 1}`,
                        name:`New Row ${newIndex + 1}`,
                        children: []
                    }

                    let sequences = [...changeSequence]

                    selectedNodes.map((node) => {
                        sequences = removeDragNDropData(node, sequences)
                        loopThruItems(treeData, node)
                    })

                    // setChangeSequence(sequences)

                    // setTimeout(() => {
                        setNewRowList(prev => [...prev, newChildItem])
                        handleSequenceChanges('newRow', newChildItem)
                    // }, 100);

                    return 

                    function loopThruItems(newTreeData, node) {
                        for(let i = 0; i < newTreeData.length; i++) {
                            const parent = newTreeData[i]
                            if(parent.id === node) {
                                newChildItem.children.push(parent)
                            }
        
                            if(parent.children) loopThruItems(parent.children, node)
                        }
                    }

                    function removeDragNDropData(node, changeSequence) {
                        const id = node.substring(node.indexOf('-') + 1);
                        const dndList = changeSequence.filter(i => {
                            if (i.step !== "dragAndDrop") return true; // Keep non-dragAndDrop steps
                            const dragId = i.newData?.dragIds?.[0];
                            return dragId !== id;
                        });
                        return dndList
                    }
                    

                    if(gridGroupLevel === 3)
                    {
                        selectedNodes.map((node) => {
                            const parent = node.split("-")[2]
                            const sub = node.split("-")[3]
                            const childId = node
                            
                            const childData = treeData.find(parentItem => {
                                if (parentItem.name === parent) {
                                    const subItem = parentItem.children.find(subItem => subItem.name === sub);
                                    if (subItem) {
                                        const child =  subItem.children.find(childItem => childItem.id === childId);
                                        if(child) {
                                            newChildItem.children.push(child)
                                            return true
                                        }
                                        return false;
                                    }
                                    return false;
                                }
                                return false;
                            });
                        })
                        
                        setNewRowList(prev => [...prev, newChildItem])
                    } else if(gridGroupLevel === 2) {
                        selectedNodes.map((node) => {
                            const subName = node.split("-")[2]
                            const childId = node
                            const childData = treeData.find(sub => {
                                if (sub.name === parent) {
                                    const subItem = sub.children.find(subItem => subItem.id === node);
                                    newChildItem.children.push(subItem)
                                }
                                return false;
                            });
                        })
                        
                        console.log(newChildItem)
                        setNewRowList(prev => [...prev, newChildItem])
                    } else if(gridGroupLevel === 1) {
                        selectedNodes.map((node) => {
                            const childData = treeData.find(item => {
                                if (item.id === node) {
                                    newChildItem.children.push(item)
                                }
                                return false;
                            });
                        })

                        const smallestItem = newChildItem.children.reduce((minItem, currentItem) => {
                            const currentIdNumber = parseInt(currentItem.id.split('-')[0], 10);
                            const minIdNumber = parseInt(minItem.id.split('-')[0], 10);
                            
                            return currentIdNumber < minIdNumber ? currentItem : minItem;
                        });

                        const firstRowIndex = smallestItem.id.split("-")[0]

                        if (treeData[firstRowIndex - 2] && treeData[firstRowIndex - 2].sqlId)
                            newChildItem.nextTo = treeData[firstRowIndex - 2].sqlId

                        setNewRowList(prev => [...prev, newChildItem])
                    }
                }
                
            break;
            case "sub": 
            break;
            case "parent": 
            break;
        }
        setSelectedNode(['',''])
        setSelectedNodes([])
        // const newParentItem = {
        //     id: `${newIndex}-parent-New Row ${newIndex}`,
        //     name:`New Row ${newIndex}`,
        //     children: []
        // }
        // setNewRowList(prev => [...prev, newParentItem])
        // const newSubItem = {
        //     id: `${newIndex + 1}-sub-${newParentItem.name}-New Row ${newIndex + 1}`,
        //     name:`New Row ${newIndex + 1}`,
        //     children: []
        // }
        // setNewRowList(prev => [...prev, newSubItem])
        // const newChildItem = {
        //     id: `${newIndex + 2}-child-${newParentItem.name}-New Row ${newIndex + 1}-New Row ${newIndex + 2}`,
        //     name:`New Row ${newIndex + 2}`,
        //     value: newRow
        // }
        // setNewRowList(prev => [...prev, newChildItem])
    }
    const handleRevertChanges = (e) => {
        e.preventDefault()
        setAlert(
            <ReactBSAlert
                warning
                title="Revert Changes"
                onConfirm={() => {
                    revertChanges()
                    setAlert(null);
                }}
                onCancel={() => setAlert(null)}
                confirmBtnBsStyle="warning"
                cancelBtnText="Cancel"
                showCancel={true}
                confirmBtnText="Ok"
                btnSize=""
            >
                <p>Are you sure you want to revert changes?</p>
            </ReactBSAlert>
        );
    }
    const handleFormulaWarning = (message) => {
        setAlert(
            <ReactBSAlert
                warning
                title="Formula Error"
                onConfirm={() => {
                    setAlert(null);
                }}
                onCancel={() => setAlert(null)}
                confirmBtnBsStyle="warning"
                cancelBtnText="Cancel"
                showCancel={true}
                confirmBtnText="Ok"
                btnSize=""
            >
                <p>{message}</p>
            </ReactBSAlert>
        );
    }
    const revertChanges = () => {
        setOnEditCell(false)
        setDragAndDropData([])
        setNewRowList([])
        setCellFormulaList([])
        setRenamedSQLData([])
        setHiddenRow([])
        setAddedNewColumnHeader([])
        setChangeSequence([])
    }
    const handleExitPage = (e) => {
        e.preventDefault()
        handleToggleEditGrid()
    }
    const handleCellClick = (cellId, rowId, sqlId) => {

        let newCellId = cellId
        
        // console.log({ onEditCell, cellId, selectedCellId })
        if (onEditCell && cellId !== selectedCellId) {
            let updatedFormula;
            const lastChar = currentFormulaStr.slice(-1);

            if(sqlId.includes("-TotalRow")) {
                const parts = sqlId.split('-');
                const secondToLastItem = parts.slice(1, -1).join('-');
                newCellId = `[${secondToLastItem}-${getFirstLetters(cellId)}]`
            }

            if(sqlId.includes("grand-total")) {
                newCellId = `[${sqlId}-${TableHeader(cellId)}]`
            }

            function getFirstLetters(str) {
                const match = str.match(/^[A-Za-z]+/);
                return match ? match[0] : '';
            };

            if (['+', '-', '*', '/','('].includes(lastChar)) {
                // If the last character is an operator, append the new cell ID
          
                updatedFormula = `${currentFormulaStr}${newCellId}`;
            } else {
                // Otherwise, replace the last referenced cell with the new cell ID
                const lastOperand = currentFormulaStr.match(/([A-Z]+\d+)$/); // Match the last cell reference
                if (lastOperand) {
                    updatedFormula = currentFormulaStr.replace(lastOperand[0], newCellId);
                } else {
                    updatedFormula = `${newCellId}`;
                }
            }
            

            setSelectedCellFormula(updatedFormula);
        }
    };
    const handleCellDoubleClick = (cellId, rowId, sqlId) => {
        if(onEditCell) return  
        setSelectedRowSQLId(sqlId)
        setSelectedRowId(rowId)
        setSelectedCellId(cellId)
        handleToggleCellEdit(true)
        if(cellFormulaList.length === 0) {
            setSelectedCellFormula(`${cellId}`)
        }else {
            const formulaItem = cellFormulaList.find(f => f.rowId === rowId && f.cellId === cellId)
            if(formulaItem) setSelectedCellFormula(formulaItem.formula)
            else setSelectedCellFormula(`${cellId}`)
        }
    };
    const handleToggleCellEdit = (value) => {
        if(!value) {
            setSelectedRowSQLId('')
            setSelectedCellId('')
            setSelectedRowId('')
            currentFormulaStr = ''
            setSelectedCellFormula('')
        }
        setOnEditCell(value)
    }
    const handleSaveFormula = (cellId, rowId, formula, sqlId, applyToAllFormula = false) => {
        // try{

            let currentFormula = formula.trim()

            setSelectedRowSQLId('')
            setSelectedCellId('')
            setSelectedRowId('')
            currentFormulaStr = ''
            setSelectedCellFormula('')

            // if(currentFormula === '' || currentFormula.length === 0) 
            //     currentFormula = '0'

            if(currentFormula === '' || currentFormula.length === 0)
            {
                if(applyToAllFormula)
                {
                    const newFormulaList = cellFormulaList.filter(f => f.sqlId !== sqlId)
                    setCellFormulaList(newFormulaList)
                } else {
                    const newFormulaList = cellFormulaList.filter(f => f.rowId !== rowId || f.cellId !== cellId)
                    setCellFormulaList(newFormulaList)
                }
            } else {

                // if (currentFormula.includes('(') || currentFormula.includes(')')) {
                //     handleFormulaWarning("formula format with '(' ')' is currently not yet supported")
                //     return
                // }

                if(applyToAllFormula)
                {
                    processapplyToAllColumnFormula(cellId, rowId, currentFormula, sqlId)
                }else {
                    const parsedFormula = NewParseFormula(currentFormula)
                    
                    const data = []
                    const uniqueFormula = parsedFormula && parsedFormula.map(i => {
                        const childVal = childListCellValue.find(item => item.cellId === i)
                        if(childVal)
                            data.push({sqlId :childVal.sqlId, cellId: i })
                    })
    
                    const param = {
                        sqlId: sqlId,
                        rowId: rowId,
                        cellId: cellId,
                        formula: currentFormula,
                        cellIdwithSQLId: data,
                        newValue: processFormula(currentFormula, cellFormulaList, childListCellValue, cellId, sqlId),
                        originalValue: getCellOldValue(cellId)
                    }

                    setCellFormulaList(prevParams => {
                        const existingIndex = prevParams.findIndex(p =>
                            p.cellId === param.cellId
                        );
                        if (existingIndex !== -1) {
                            const updatedParams = [...prevParams];
                            updatedParams[existingIndex] = param;
                            return updatedParams;
                        } else {
                            return [...prevParams, param];
                        }
                    })
                }
            }
        // } catch (error) {
        //     console.error(`Error processing formula: ${error.message}`);
        // }
    }   
    const processapplyToAllColumnFormula = (cellId, rowId, currentFormula, sqlId) => {
        const columnCount = (columnHeader.length - gridGroupLevel) + (addedNewColumnHeader ? addedNewColumnHeader.length : 0)

        for(let i = 0; i < columnCount; i++)
        {
            const cellId = `${TableHeader(i)}${rowId.split("-")[0]}`
            const parsedFormula = NewParseFormula(currentFormula)
            // console.log(parsedFormula)
            const data = []
            let newFormula = ""

            const uniqueFormula = parsedFormula && parsedFormula.map(f => {
                const childVal = childListCellValue.find(item => item.cellId === f)
                if(childVal) {

                    // console.log(childVal.cellId.replace("-A", `-${TableHeader(i)}`))
                    if(validateBrackets(childVal.cellId))
                    {
                        data.push({id :childVal.id, sqlId :childVal.sqlId, cellId: childVal.cellId.replace("-A]", `-${TableHeader(i)}]`), columnIndex: i})
                        newFormula += childVal.cellId.replace("-A]", `-${TableHeader(i)}]`)
                    } else {
                        data.push({id :childVal.id, sqlId :childVal.sqlId, cellId: childVal.cellId.replace("A", `${TableHeader(i)}`), columnIndex: i})
                        newFormula += childVal.cellId.replace("A", `${TableHeader(i)}`)
                    }
                    // console.log({id :childVal.id, sqlId :childVal.sqlId, cellId: childVal.cellId.replace("A", `-${TableHeader(i)}`), columnIndex: i, OrigCellId: childVal.cellId})
                   
                } else {
                    data.push({operator: f})
                    newFormula += f
                }
            })
            function validateBrackets(str)
            {
                const regex = /^\[.*\]$/;
                return regex.test(str);
            };
            
            const param = {
                sqlId: sqlId,
                rowId: rowId,
                cellId: cellId,
                formula: newFormula,
                cellIdwithSQLId: data,
                newValue: processFormula(newFormula, cellFormulaList, childListCellValue, cellId, sqlId),
                originalValue: getCellOldValue(cellId)
            }

            setCellFormulaList(prevParams => {
                const existingIndex = prevParams.findIndex(p =>
                    p.cellId === param.cellId
                );
                if (existingIndex !== -1) {
                    const updatedParams = [...prevParams];
                    updatedParams[existingIndex] = param;
                    return updatedParams;
                } else {
                    return [...prevParams, param];
                }
            })
        }
    }
    const getCellOldValue = (selectedCellId) => {
        const cellData = childListCellValue.find(c => c.cellId === selectedCellId)
        return cellData ? cellData.cellValue : 0
    }
    const processFormula = (formula, cellFormulaList, childListCellValue, selectedCellId, sqlId) => {
    
        if(!childListCellValue) return ''


        // console.log({formula, cellFormulaList, childListCellValue, selectedCellId, sqlId})

        // if(!formula.startsWith('=')) 
        // {
        //     return isNaN(formula) ? formula : parseFloat(formula)
        // }else{
        // console.log({sqlId, formula})
        const parsedFormula = NewParseFormula(formula)
        // console.log(parsedFormula)
        if(!parsedFormula || (parsedFormula && parsedFormula.length === 0)) return formula
        // if(parsedFormula.length === 1) return parsedFormula[0]

        const replacedFormula = ReplaceCellIdsWithValues(parsedFormula, cellFormulaList, childListCellValue, selectedCellId, selectedRowHeaderforFormula)
        // console.log(replacedFormula)
        const finalResult = EvaluateFormula(replacedFormula);
        // console.log(finalResult)

        return finalResult
        // }
    }
    const NewParseFormula = (formula) => {
        const sumMatch = formula.match(/=sum\((.*)\)/i);
        const avgMatch = formula.match(/=avg\((.*)\)/i);
    
        if (sumMatch) {
            const [_, parent] = sumMatch[1].match(/([A-Z]+\d+)/);
            return { function: 'sum', parent: parent.trim() };
        } else if (avgMatch) {
            const [_, parent] = avgMatch[1].match(/([A-Z]+\d+)/);
            return { function: 'avg', parent: parent.trim() };
        }
    
        // Updated regex to handle text labels within brackets, cell references, and operators
        // const regex = /(\[[^\]]+\])|([A-Z]+\d+)|([\+\-\*\/])|(-?\d+(\.\d+)?)/g;
        if (typeof formula === 'string' && formula.startsWith("'") && formula.endsWith("'")) {
            return [formula];
        }

        const regex = /(\[[^\]]+\])|([A-Z]+\d+)|([\+\-\*\/])|(-?\d+(\.\d+)?)/g;
        const matches = formula.match(regex);
        
        // Filter out empty matches
        const result = matches ? matches.filter(match => match.trim()) : [];
    
        return result;
    };
    // const NewParseFormula = (formula) => {
    //     const sumMatch = formula.match(/=sum\((.*)\)/i);
    //     const avgMatch = formula.match(/=avg\((.*)\)/i);
        
    //     if (sumMatch) {
    //         const [_, parent] = sumMatch[1].match(/([A-Z]+\d+)/);
    //         return { function: 'sum', parent: parent.trim() };
    //     } else if (avgMatch) {
    //         const [_, parent] = avgMatch[1].match(/([A-Z]+\d+)/);
    //         return { function: 'avg', parent: parent.trim() };
    //     }
    
    //     // Updated regex to handle text labels, cell references, and operators
    //     const regex = /([A-Z]+\d+)|([\+\-\*\/])|(-?\d+(\.\d+)?)|([A-Za-z\s]+)/g;
    //     const matches = formula.match(regex);
    
    //     // Filter out empty matches
    //     const result = matches ? matches.filter(match => match.trim()) : [];
    
    //     return result;
    // };
    const ReplaceCellIdsWithValues = (parsedFormula, cellFormulaList, childListCellValue, selectedCellID, selectedRowHeaderforFormula) => {
        return parsedFormula.map(token => {
            try {
                const newToken = token.trim()
                if (/[\+\-\*\/]/.test(newToken) && newToken.length === 1) {
                    return newToken; // If the token is an operator or a number, return it as is
                } else {
                    
                    const rowHeader = selectedRowHeaderforFormula.find(i => i.nodeName === newToken)
                    if(rowHeader)
                    {
                        const cell = childListCellValue.find(cell => cell.sqlId === rowHeader.sqlId);
                        if(cell) return cell.cellValue
                    }
                
                    const cellFormula = cellFormulaList.length > 0 ? cellFormulaList.filter(f => f.cellId === newToken) : []
                    // const cell = childListCellValue.find(cell => cell.cellId === newToken);
                    const cell = Array.isArray(childListCellValue)
                        ? childListCellValue.find(cell => cell.cellId === newToken)
                        : undefined;
                

                    if(cellFormula.length > 0 && selectedCellID !== newToken)
                    {
                        return cellFormula[0].newValue
                    }
                
                    if(cell && cellFormula.length > 0 && selectedCellID !== newToken)
                    {     
                        if(cellFormula[0].originalValue !== cell.cellValue) 
                            return cell.cellValue
                        else 
                            return cellFormula[0].newValue
                    } else {
                        if (cell) {
                            return cell.cellValue;
                        } else {
                            if(isNaN(newToken))
                                return newToken
                            else 
                                return newToken
                        }
                    }
                }
            } catch (error) {
                console.log(error)
            }
        });
    };
    const EvaluateFormula = (replacedFormula) => {
        let isPercentage = false

        if ((replacedFormula[0] === '-' || replacedFormula[0] === '+') && typeof replacedFormula[1] === 'number' && replacedFormula.length === 2) {
            replacedFormula[1] = replacedFormula[1] * -1;
            replacedFormula.shift();
        }

        const convertedFormula = replacedFormula.map(item => {
            if (typeof item === 'string' && item.includes('%')) {
                isPercentage = true
                return parseFloat(item.replace('%', '').trim())
            }
            return item;
        });
        const expression = convertedFormula.join('');

        let result;
        try {
            result = eval(expression);
        } catch (error) {
            // console.error('Error evaluating formula:', error);
            return (`${error}`).replace("ReferenceError: ", "");
        }

        // Convert the result back to a percentage string
        if(isPercentage) 
            return `${result.toFixed(2)} %`
        else
            return result;
    };
    let currentFormulaStr = ''
    const getCurrentFormula = (currentFormula) => {
        if(onEditCell)
            currentFormulaStr = currentFormula
    }
    const handleHideRow = (e, selectedNode) => {
        e.preventDefault();
        
        setHiddenRow(prev => {
            if (!Array.isArray(prev)) {
                prev = [];
            }

            if(prev.includes(selectedNode[1])) return prev.filter(id => id !== selectedNode[1])
            else return [...prev, selectedNode[1]];
        })
    }
    const [alert, setAlert] = useState(false);
    const handleSaveNameRename = (param) => {
        const addedColumn = addedNewColumnHeader.findIndex(i => i.colIndex === param.colIndex)
        if(addedColumn !== -1) {
            addedNewColumnHeader[addedColumn].name = param.newHeader
            setAddedNewColumnHeader(addedNewColumnHeader)
        } else {
            param.sqlId = getSQLID(columnHeaderData, param)
            setRenamedHeaderList(prev => {
                if (!Array.isArray(prev)) {
                    prev = [];
                }

                const index = prev.findIndex(i => i.colIndex === param.colIndex)
                if(index === -1) return [...prev, param];
                else {
                    
                    return [...prev.filter(i => i.colIndex !== param.colIndex), param];
                }
            })
        }

        setNewUpdateCount(prev => prev + 1)

        function getSQLID(columnHeaderData, param)
        {
            const item = columnHeaderData.find(i => i.colIndex === param.colIndex)
            return item.sqlId
        }
    }
    const handleAddColumn = () => {
        const param = {
            colIndex: columnHeaderData.length + (addedNewColumnHeader ? addedNewColumnHeader.length: 0), 
            sqlId: GenerateUniqueID(),
            name: `New Column`
        }

        setAddedNewColumnHeader(prev => {
            if (!Array.isArray(prev)) {
                prev = [];
            }
            return [...prev, param];
        })
    }
    const handleRemoveColumn = (e, selectedHeader) => {
        e.preventDefault()
        const colIndex = selectedHeader.index
        const newAddedNewColumnHeader = addedNewColumnHeader.filter( i => i.colIndex !== colIndex)

        // remove column header
        setAddedNewColumnHeader(newAddedNewColumnHeader)
        const dynamicHeader = TableHeader(colIndex - 1);
        
        // remove cell with formula
        const filteredCellFormulaList = filterOutDynamicCReferences(cellFormulaList, dynamicHeader);
        setCellFormulaList(filteredCellFormulaList)

        function filterOutDynamicCReferences(cellFormulaList, dynamicHeader) {
            const regex = new RegExp(`${dynamicHeader}\\d+`);

            const removedWithCellId = cellFormulaList.filter(i => !regex.test(i.cellId))
            return removedWithCellId
        }
    }
    const RenderSettings = ({ selectedNode, selectedCellId, selectedRowId, selectedRowSQLId, selectedCellFormula, onEditCell, 
        handleToggleCellEdit, handleSaveFormula, getCurrentFormula, cellFormulaList, isGridSubWithChild, isGridWithChild, isSubWithChild, handleHideRow, selectedHeader, handleSaveNameRename, handleAddColumn }) => {

        const [applyToAllFormula, setApplyToAllFormula] = useState(false);
        const [isWithChild, setIsWithChild] = useState(false);
        const [isWithTotal, setIsWithTotal] = useState(false);
        const [itemName, setItemName] = useState(null);
        const [header, setHeader] = useState(selectedHeader)
        const [newUpdates, setNewUpdates] = useState(0)
        const [currentFormula, setCurrentFormula] = useState(selectedCellFormula)

        //#region add/remove row
        useEffect(() => {
            setItemName(selectedNode[2]);

            if(selectedHeader)
                setItemName(header?.header);
            // console.log(selectedNode)
        }, [selectedNode, newUpdates, selectedHeader]);
    
        const groupLevel = selectedNode[0] 
        ? selectedNode[0].includes("-") 
            ? selectedNode[0]
                .split("-")[1]
                .charAt(0).toUpperCase() + selectedNode[0].split("-")[1].slice(1).toLowerCase()
            : '' 
        : ''; 
    
        // console.log(selectedNode)
        // console.log(selectedNodes)

        const handleChangeItemName = (event) => {
            setItemName(event.target.value);
        };
        const handleRenameHeader = (e, selectedHeader) => {
            e.preventDefault();
            const param = {
                colIndex: selectedHeader.index,
                oldHeader: selectedHeader.header,
                newHeader: itemName
            }
            handleSaveNameRename(param)
        };
        const handleRenameNewRow = (e, selectedNode) => {
            e.preventDefault();
            const newData = [...newRowList]
            const newRowToUpdate = newData.find(row => row.sqlId === selectedNode[1])
            setSelectedNode([selectedNode[0],selectedNode[1], itemName, selectedNode[3]])
            if(newRowToUpdate){
                newRowToUpdate.name = itemName
                setNewRowList(newData)
                setNewUpdates(prev => prev + 1)
            } else {
                processRenameSQLData(selectedNode, itemName)
            }
        };
        const processRenameSQLData = (selectedNode, itemName) => {
            const param = {
                id: selectedNode[1],
                oldName: selectedNode[2],
                newName: itemName
            }
            setRenamedSQLData(prev => {
                if (!Array.isArray(prev)) {
                    prev = [];
                }
                
                return [...prev, param];
            })
        }
        const handleRemoveRow = async (e, selectedNode) => {
            console.log([...changeSequence])


            const newCellFormulaList = cellFormulaList.filter(i => i.rowId !== selectedNode[0])
            setCellFormulaList(newCellFormulaList)
            setSelectedNode(['',''])

            const groupLevel = selectedNode[0].split("-")[1]
            let newSequence = changeSequence.filter(seq => seq.newData?.sqlId !== selectedNode[1])
            newSequence = newSequence.filter(seq => seq.newData?.parentId !== selectedNode[1])
            if(groupLevel === "child" || groupLevel === "sub")
            {
                newSequence = await removeChildById(newSequence, selectedNode[0])
            }
            setChangeSequence(newSequence)


            const newRowData = [...newRowList]
            let updatedRowListParent = newRowData.filter(row => row.id !== selectedNode[0])
            setNewRowList(updatedRowListParent)

            return
            e.preventDefault();

            const newData = [...newRowList]
            // const groupLevel = selectedNode[0].split("-")[1]
            let updatedRowList = newData.filter(row => row.id !== selectedNode[0])
            let newDragAndDropData = dragAndDropData && dragAndDropData.filter(item => item.dragIds[0] !== selectedNode[0])
            newDragAndDropData = newDragAndDropData.length > 0 && newDragAndDropData.filter(item => item.parentId !== selectedNode[0])

            if(groupLevel === "child" || groupLevel === "sub")
            {
                updatedRowList = removeChildById(updatedRowList, selectedNode[0]);
                updatedRowList = updatedRowList.filter(row => row.id.split("-")[3] !== selectedNode[1])

                if(newDragAndDropData && newDragAndDropData.length > 0)
                newDragAndDropData = newDragAndDropData.length > 0 && newDragAndDropData.filter(item => item.dragIds[0].split("-")[3] !== selectedNode[1])
            } else if(groupLevel === "parent") 
            {
                updatedRowList = updatedRowList.filter(row => row.id.split("-")[2] !== selectedNode[1])
                if (newDragAndDropData && newDragAndDropData.length > 0) {
                    newDragAndDropData = newDragAndDropData.filter(item => {
                        const dragIdPart = item.dragIds[0]?.split("-")[2];
                        const parentIdPart = selectedNode[0]?.split("-")[2];

                        return dragIdPart !== selectedNode[1] && (!item.parentId || !item.parentId.includes(`sub-${parentIdPart}`));
                    });
                }
            }

            setDragAndDropData(newDragAndDropData)
            setNewRowList(updatedRowList)

        };
        const removeChildById = async (rowList, childIdToRemove) => {
            return rowList.map(row => {
                if (row?.newData?.children) {
                    const filteredChildren = row.newData.children.filter(child => child.id !== childIdToRemove);
                    console.log("Filtered:", filteredChildren);
                    console.log("Original:", row.newData.children); // this will still be original in the next line
        
                    return {
                        ...row,
                        newData: {
                            ...row.newData,
                            children: filteredChildren
                        }
                    };
                }
                return row;
            });
        };
        
        // const removeChildById = (rowList, childIdToRemove) => {
        //     // return rowList.map(row => {
        //     //     if (row.children) {
        //     //         // Filter out the child with the matching ID
        //     //         row.children = row.children.filter(child => child.id !== childIdToRemove);
        //     //     }
        //     //     return row;
        //     // })
        //     // .filter(row => {
        //     //     // Remove the parent or sub if it had only one child and that child was removed
        //     //     return !(row.children && row.children.length === 0);
        //     // });
        // };
        
        //#endregion

        useEffect(() => {
            getCurrentFormula(currentFormula)
        },[currentFormula])

         useEffect(() => {
            // console.log(selectedCellFormula)
        },[selectedCellFormula])

        const handleFormulaChange = (event) => {
            setCurrentFormula(event.target.value);
        }
        const handleCancelEdit = () => {
            handleToggleCellEdit(false)
        }
        const onHandleSaveFormula = () => {
            setCurrentFormula('')
            getCurrentFormula('')
            handleToggleCellEdit(false)
            handleSaveFormula(selectedCellId, selectedRowId, currentFormula, selectedRowSQLId, applyToAllFormula)
        }
        const onHandleHideRow = (e, selectedNode, hiddenRow) => {
            e.preventDefault();
            selectedNode[0] = selectedNode[0].replace("-TotalRow","")
            setSelectedNode([selectedNode[0], selectedNode[1], selectedNode[2], hiddenRow === undefined ? true : !hiddenRow])
            handleHideRow(e, selectedNode)
        }
        const onHandleAddColumn = (e) => {
            e.preventDefault();
            handleAddColumn()
        }
        return (
            <div className='gridSetting'>
                <div>
                    {!onEditCell ?
                    <>
                        {header ? 
                        <>
                            <FormGroup>
                                <Label>Item Name:</Label>
                                <Input 
                                    value={itemName}
                                    disabled={selectedNode[0].includes("-TotalRow")}
                                    onChange={handleChangeItemName}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' && selectedHeader?.header !== itemName) {
                                            e.preventDefault();
                                            handleRenameHeader(e, selectedHeader);
                                        }
                                    }}
                                />

                                {selectedHeader?.header !== itemName  &&
                                    <div style={{ display: 'flex', flexDirection: 'row-reverse', marginTop: 10 }}>
                                    <Button color="primary" type="button" size="sm" onClick={e => handleRenameHeader(e, selectedHeader)}>
                                        Save Name
                                    </Button>
                                    </div>
                                }
                            </FormGroup>
                            <FormGroup>
                                <Button
                                    color="primary"
                                    type="button"
                                    size="sm"
                                    onClick={e => onHandleAddColumn(e)}
                                >
                                    Add New Column
                                </Button>
                                <Button color="danger" size="sm" outline type="button" 
                                    onClick={e => handleRemoveColumn(e, selectedHeader)}
                                >
                                    Remove Column
                                </Button>
                            </FormGroup>
                        </>
                        :
                        <>
                            <FormGroup>
                                <Label>Item Name:</Label>
                                <Input 
                                    value={itemName}
                                    disabled={selectedNode[0].includes("-TotalRow")}
                                    onChange={handleChangeItemName}
                                />

                                {selectedNode[2] !== itemName  &&
                                    <div style={{ display: 'flex', flexDirection: 'row-reverse', marginTop: 10 }}>
                                    <Button color="primary" type="button" size="sm" onClick={e => handleRenameNewRow(e, selectedNode)}>
                                        Save Name
                                    </Button>
                                    </div>
                                }
                            </FormGroup>
                            <FormGroup>
                            {(groupLevel === "Parent" || groupLevel === "Sub") && (
                                <>
                                    <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
                                        <div className="checkbox-option">
                                            <input
                                            type="checkbox"
                                            id="subWithChild"
                                            name="dashboardType"
                                            checked={isWithChild}
                                            onChange={() => setIsWithChild(!isWithChild)}
                                            />
                                            <label htmlFor="subWithChild" style={{ marginLeft: 10 }}>with child row?</label>
                                        </div>
                                        <Button
                                            color="primary"
                                            type="button"
                                            size="sm"
                                            onClick={e => handleAddRow(e, selectedNode, isWithChild)}
                                        >
                                            Add {groupLevel} Row
                                        </Button>
                                    </div>
                                    <Button
                                        color="info"
                                        type="button"
                                        size="sm"
                                        onClick={e => handleAddRow(e, selectedNode, false, true)}
                                        >
                                        Add Child Row
                                    </Button>

                                    {(selectedNode && selectedNode[0] && !selectedNode[0].includes("New Row")) && (
                                    selectedNode[3] !== undefined &&  selectedNode[3] ? (
                                        <Button
                                        color="success"
                                        size="sm"
                                        type="button"
                                        onClick={e => onHandleHideRow(e, selectedNode, selectedNode[3])}
                                        >
                                        Show {groupLevel} Row
                                        </Button>
                                    ) : (
                                        <Button
                                        color="danger"
                                        size="sm"
                                        outline
                                        type="button"
                                        onClick={e => onHandleHideRow(e, selectedNode, selectedNode[3])}
                                        >
                                        Hide {groupLevel} Row
                                        </Button>
                                    )
                                    )}
                                </>
                                )}


                                {groupLevel === "Child" && selectedNodes.length <= 1 && (
                                    <>
                                        <Button color="primary" type="button" size="sm" onClick={e => handleAddRow(e, selectedNode)}>
                                            Add {groupLevel} Row
                                        </Button>

                                        {selectedNode[3] !== undefined && selectedNode[3] ? 
                                        <Button color="success" size="sm" type="button" onClick={e => onHandleHideRow(e, selectedNode, selectedNode[3])}>
                                            Show {groupLevel} Row
                                        </Button>
                                        :
                                        <Button color="danger" size="sm" outline type="button" onClick={e => onHandleHideRow(e, selectedNode, selectedNode[3])}>
                                            Hide {groupLevel} Row
                                        </Button>}
                                    </>
                                )}

                                {(selectedNode[0].includes("grand-total") || selectedNode[0].includes("grandParent")) && selectedNodes.length <= 1 && (
                                    <>
                                        <Button color="primary" type="button" size="sm" onClick={e => handleAddRow(e, selectedNode)}>
                                            Add Grand Parent Row
                                        </Button>
                                    </>
                                )}

                                {(selectedNode[0] && selectedNode[0].includes("New Row"))  && groupLevel !== "Grouptotal" && selectedNodes.length === 1 &&(
                                    <Button color="danger" size="sm" outline type="button" onClick={e => handleRemoveRow(e, selectedNode)}>
                                        Remove {groupLevel} Row
                                    </Button>
                                )}
                            </FormGroup>
                            <FormGroup>
                                {selectedNodes.length > 1 &&
                                    <div style={{ display: 'flex', gap: 10 }}>
                                        <Button color="success" type="button" size="sm" onClick={e => handleAddParentGroupings(e, selectedNode, isWithTotal)}>
                                            Add Group Row
                                        </Button>
                                    </div>
                                }
                            </FormGroup>
                        </>}
                    </>
                    :
                    <>
                        <FormGroup>
                            <Label>Cell Id:</Label>
                            <Input 
                                value={selectedCellId}
                                disabled
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Formula:</Label>
                            <Input 
                                type="textarea"
                                value={currentFormula}
                                onChange={handleFormulaChange}
                            />
                            <div style={{ display: 'flex', flexDirection: 'row-reverse', marginTop: 10, gap: 0 }}>
                               
                                <Button color="danger" size="sm" outline type="button" onClick={handleCancelEdit}>
                                    Cancel
                                </Button>
                                <Button color="primary" type="button" size="sm" onClick={onHandleSaveFormula}>
                                    Save
                                </Button>
                                <div className="checkbox-option">
                                    <input
                                        type="checkbox"
                                        id="applyToAllFormula"
                                        name="dashboardType"
                                        checked={applyToAllFormula}
                                        onChange={() => setApplyToAllFormula(!applyToAllFormula)}
                                    />
                                    <label htmlFor="applyToAllFormula" style={{ marginRight: 10 }}>Apply to All Column?</label>
                                </div>
                            </div>
                        </FormGroup>
                    </>
                    }
                </div>
                <div>
                    <div className='btmButton'>
                        <Button color="danger" type="button" size="sm" onClick={e => handleExitPage(e)}>
                            Exit
                        </Button>

                        {(dragAndDropData.length > 0 || newRowList.length > 0 || cellFormulaList.length > 0) &&
                            <Button color="danger" type="button" outline size="sm" onClick={e => handleRevertChanges(e)}>
                                Revert Changes
                            </Button>
                        }
                        <Button color="primary" type="button" size="sm" onClick={e => handleSaveChanges(e)}>
                            Save Changes
                        </Button>
                    </div>
                </div>
            </div>
        );
    };
    function Node({ node, style, dragHandle }) {
        return (
          <div style={style} ref={dragHandle} className='treeItemContainer'>
            <div 
                onClick={(e) => handleTreeItemClick(e, node.data.id, node.data.sqlId, node.data.name, node.data.isHidden)} 
                className={`treeItem ${node.data.id} ${
                node.data.id.includes('-sub-') ? 'sub-item' :
                node.data.id.includes('-parent-') ? 'parent-item' :
                node.data.id.includes('-grandParent-') ? 'grandParent-item' :
                node.data.id.includes('-child-') ? 'child-item' :
                node.data.id.includes('-group-') ? 'group-item' :
                node.data.id.includes('-groupTotal-') ? 'groupTotal-item' : ''} 
                ${node.data.isHidden ? 'rowHidden' : ''}
                ${node.data.id.includes('-TotalRow') ? 'tree-total-row' : ''}
                ${selectedNodes.includes(node.data.id) ? 'selectedItem' : ''}
                ${node.data.id === selectedNode[0] ? 'selectedItem' : ''} 
                ${node.data.id.includes("New Row") ? 'addedRow' : ''}`}
            >
                {node.data.name}
            </div>
          </div>
        );
    }
    const canDrag = (node) => {
        // Prevent dragging for nodes with '-TotalRow-' in their id
        return !node.data.id.includes('-TotalRow-') || !node.data.id.includes('grand-total');
    };
    const handleSelectHeader = (index, header) => {
        setSelectedHeader({index, header})
        setSelectedNode(['',''])
        setSelectedNodes([]);
    }
    return (
        
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', height: '100%'}}>
            <div className='editGridContent'>
                {alert}
                <div className='editGridContainer' style={{ height: rowIndexCount * 30}}>
                    {treeData && treeData.length > 0 && (
                        <Tree
                            data={treeData}
                            width={400}
                            height={rowIndexCount * 37 + 500}
                            indent={24}
                            rowHeight={37}
                            overscanCount={1}
                            paddingTop={30}
                            paddingBottom={10}
                            padding={10}
                            overflow={'hidden'}
                            // marginBottom={5}
                            onMove={onMove}
                            canDrag={canDrag}
                        >
                            {Node}
                        </Tree>
                    )}
                </div>
                <div className='tableContainer'>
                    <GridContent
                        tableHeader={tableHeader}
                        treeData={treeData}
                        isWithChild={isWithChild}
                        selectedCellId={selectedCellId}
                        onEditCell={onEditCell}
                        cellFormulaList={cellFormulaList}
                        childListCellValue={childListCellValue}
                        gridGroupLevel={gridGroupLevel}
                        selectedCellFormula={selectedCellFormula}
                        handleCellDoubleClick={handleCellDoubleClick}
                        handleCellClick={handleCellClick}
                        processFormula={processFormula}
                        handleSelectHeader={handleSelectHeader}

                    />
                </div>
            </div>
            <RenderSettings 
                selectedNode={selectedNode}
                selectedCellId={selectedCellId} 
                selectedRowId={selectedRowId}
                selectedRowSQLId={selectedRowSQLId}
                selectedCellFormula={selectedCellFormula}
                onEditCell={onEditCell}
                cellFormulaList={cellFormulaList}
                isGridWithChild={isWithChild}
                isGridSubWithChild={isSubWithChild}
                isSubWithChild={isSubWithChild}
                handleToggleCellEdit={handleToggleCellEdit}
                handleSaveFormula={handleSaveFormula}
                setSelectedCellFormula={setSelectedCellFormula}
                getCurrentFormula={getCurrentFormula}
                handleHideRow={handleHideRow}
                handleTreeItemClick={handleTreeItemClick}
                selectedHeader={selectedHeader}
                handleSaveNameRename={handleSaveNameRename}
                handleAddColumn={handleAddColumn}
                handleRemoveColumn={handleRemoveColumn}
            />
        </div>
    );
}
export default GridEditLayout;
